<mat-drawer-container class="dashboard">
    <mat-drawer [opened]="isDrawerOpen" class="max-w-[350px]" mode="side">
        <app-site-nav></app-site-nav>
    </mat-drawer>
    <mat-drawer-content>
        <app-header (toggleDrawer)="onToggleDrawer()" [userDetails]="userDetails"></app-header>
        <div class="dashboard__content">
            <div class="dashboard__content-wrapper">
                <router-outlet></router-outlet>
            </div>
        </div>
    </mat-drawer-content>
</mat-drawer-container>
